/**
 * RESPONSIBILITY: the coloured band at the top of an inner page.
 *
 * Shared because Events, Sermons, Leadership and Contact all open the same way, and four
 * copies of one band is four places to change when it moves.
 */
export function PageHead(
  { eyebrow, heading, intro }: { eyebrow?: string; heading: string; intro?: string },
) {
  return (
    <section className="page-head">
      <div className="wrap">
        {eyebrow && <p className="eyebrow">{eyebrow}</p>}
        <h1>{heading}</h1>
        {intro && <p className="lede">{intro}</p>}
      </div>
    </section>
  );
}
